export enum ApiKeysPageProps {
  PAGE_TITLE = 'Developer',
  PAGE_SUBTITLE = 'API Keys',
  CREATE_BUTTON = 'Create API Key',
  EMPTY_STATE_TITLE = 'No API keys yet',
  EMPTY_STATE_DESCRIPTION = 'Create your first API key to start integrating with CarbonOne.',
  ACCESS_DENIED_MESSAGE = 'Only admins can manage API keys.',
}

export enum ApiKeysTableColumns {
  NAME_TITLE = 'Name',
  NAME_INDEX = 'name',
  KEY_PREFIX_TITLE = 'Key',
  KEY_PREFIX_INDEX = 'key_prefix',
  SCOPES_TITLE = 'Scopes',
  SCOPES_INDEX = 'scopes',
  CREATED_TITLE = 'Created',
  CREATED_INDEX = 'createdAt',
  LAST_USED_TITLE = 'Last Used',
  LAST_USED_INDEX = 'last_used_at',
  STATUS_TITLE = 'Status',
  /** API field; true only for legacy soft-revoked rows */
  STATUS_INDEX = 'revoked',
  ACTION_TITLE = '',
  ACTION_INDEX = 'actions',
  ACTION_WIDTH = '10%',
}

export enum ApiKeysModalProps {
  CREATE_TITLE = 'Create API Key',
  CREATE_NAME_LABEL = 'Key Name',
  CREATE_NAME_PLACEHOLDER = 'e.g. Production Integration',
  CREATE_SUBMIT = 'Create',
  CREATE_CANCEL = 'Cancel',
  NAME_REQUIRED = 'Key name is required',
  NAME_MAX_LENGTH = 'Key name must be 100 characters or less',
  REVEAL_TITLE = 'API Key Created',
  REVEAL_KEY_LABEL = 'Your API key',
  REVEAL_WARNING = "You won't be able to see this key again. Copy it now.",
  REVEAL_COPY = 'Copy to Clipboard',
  REVEAL_COPIED = 'Copied!',
  REVEAL_CONFIRM = 'I have saved my key',
  REVEAL_DONE = 'Done',
  DELETE_KEY_TITLE = 'Delete API key',
  DELETE_KEY_CONFIRM =
    'Delete this key permanently? It will be removed from your account and integrations using it will stop working immediately.',
  DELETE_KEY_OK = 'Delete',
  DELETE_KEY_CANCEL = 'Cancel',
}

export enum ApiKeysMessages {
  KEY_CREATED = 'API key created successfully',
  KEY_DELETED = 'API key deleted successfully',
  KEY_COPIED = 'API key copied to clipboard',
  PERMISSION_DENIED = "You don't have permission to manage API keys.",
}

export enum ApiKeysHelpPanel {
  TITLE = 'How to use API keys',
  FULL_API_REFERENCE = 'Full API reference',
  AUTH_HEADER = 'Keys are Bearer tokens: Authorization: Bearer <API_KEY>',
  COMPANY_SCOPE = 'Keys are tied to the company of the admin who created them. Integrations act as that organization\'s data scope.',
  READ_ONLY = 'Read-only scope for v1.',
  ADMIN_ONLY = 'Only Super Admin and Admin users can create and manage API keys.',
}

export enum ApiKeyStatus {
  ACTIVE = 'Active',
  /** Shown only for legacy rows still returned with revoked: true */
  LEGACY_REVOKED = 'Revoked',
}
